var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ficheFacture"}},[_c('b-row',{staticClass:"backInfoMain2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('s-menuSave',{attrs:{"btnSaveDisabled":_vm.checkAllField,"saveBtn":""},on:{"save":function($event){return _vm.menuSave()}}})],1)],1),_c('invoice',{attrs:{"showLeftPanel":false},on:{"on-invoice":_vm.invoiceChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }